module.exports = __webpack_public_path__ + "media/addons/ExtraCopies-1cf89121.svg";